import * as XLSX from "xlsx";

/* ── Date formatter ── */
export const fmt = (d, opts = { day: "2-digit", month: "short", year: "numeric" }) => {
  if (!d) return "—";
  try { return new Date(d).toLocaleDateString("en-IN", opts); } catch { return "—"; }
};

/* ── API response array extractor ── */
export const extractArray = (res) => {
  if (!res) return [];
  for (const c of [
    res?.data?.data, res?.data?.rows, res?.data?.list,
    res?.data?.answers, res?.data?.history, res?.data, res,
  ])
    if (Array.isArray(c)) return c;
  return [];
};

/* ── API success check ── */
export const isOk = (res) =>
  Array.isArray(res) || Array.isArray(res?.data) ||
  res?.isSuccess === true || res?.success === true ||
  (typeof res?.status === "number" && res.status >= 200 && res.status < 300);

/* ── Avatar colour palette ── */
export const COLORS = [
  "#2563eb", "#16a34a", "#dc2626", "#d97706",
  "#7c3aed", "#0891b2", "#be185d", "#0f766e",
];
export const aColor = (id) => COLORS[Number(id || 0) % COLORS.length];

/* ── Supported units ── */
export const UNITS = ["kg", "ton", "litre", "kWh", "m³", "tCO₂e", "%", "hrs", "MWh", "GJ", "ML", "-"];

/* ── File-type helpers ── */
export const isSpreadsheet = (f) => /\.(csv|xlsx|xls)$/i.test(f?.name || "");

export const parseDate = (v) => {
  if (!v) return "";
  if (!isNaN(v) && Number(v) > 40000) {
    try {
      const d = XLSX.SSF.parse_date_code(Number(v));
      if (d) return `${d.y}-${String(d.m).padStart(2, "0")}-${String(d.d).padStart(2, "0")}`;
    } catch { }
  }
  const d = new Date(v);
  return isNaN(d.getTime()) ? String(v) : d.toISOString().slice(0, 10);
};

export const getCol = (row, ...keys) => {
  for (const k of keys) {
    const match = Object.keys(row).find(rk => rk.trim().toLowerCase() === k.toLowerCase());
    if (match !== undefined && row[match] !== "") return String(row[match]).trim();
  }
  return "";
};

export const getMimeLabel = (mime = "") => {
  if (mime.startsWith("image/")) return "Image";
  if (mime === "application/pdf") return "PDF";
  if (mime.includes("word")) return "Word Document";
  if (mime.includes("sheet") || mime.includes("excel")) return "Spreadsheet";
  return "Document";
};

export const isImage = (mime = "", url = "") =>
  mime.startsWith("image/") || /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(url);

export const isPdf = (mime = "", url = "") =>
  mime === "application/pdf" || /\.pdf$/i.test(url);

export function getLatestFY(financialYears) {
  if (!financialYears?.length) return null;

  return financialYears.reduce((latest, current) => {
    const currentStart = parseInt(current.financial_year_value.split("-")[0]);
    const latestStart = parseInt(latest.financial_year_value.split("-")[0]);

    return currentStart > latestStart ? current : latest;
  });
}

export const formatKey = (key) => {
  if (!key) return "";

  const map = {
    module: "Module",
    subcategory: "Sub Category",
    kpi: "KPI",
    category: "Category",
    scope: "Scope",
  };

  const normalized = key.toLowerCase().replace(/\s+/g, "");

  if (map[normalized]) return map[normalized];

  // fallback: auto format (handles unknown keys)
  return key
    .replace(/([A-Z])/g, " $1")   // split camelCase
    .replace(/^./, (c) => c.toUpperCase()) // capitalize first
    .trim();
};
